import React from 'react';
import InfoIcon from 'assets/img/infoIcon.svg';
import warningIcon from 'assets/img/warningIcon.svg';
import errorIcon from 'assets/img/errorIcon.svg';
import * as I18n from 'circe/I18n';
import SVG from 'react-inlinesvg';

export const getNotificationBody = (row) => {
  return (
    <>
      <div>{row?.notification?.body || row?.data?.body || ''}</div>
      {row?.data?.url && (
        <div>
          {' '}
          <a href={row?.data?.url} target="_blank">
            {I18n.str('clickHereToDownload', 'Click here to download it.')}
          </a>
        </div>
      )}
    </>
  );
};

const iconMap = {
  ERROR: errorIcon,
  WARNING: warningIcon,
  INFO: InfoIcon,
};

const getDefaultIcon = () => <SVG src={InfoIcon} title="info" />;

export const getNotificationIcon = (notification) => {
  const iconSrc = iconMap[notification?.data?.type];
  const iconComponent = iconSrc ? (
    <SVG src={iconSrc} title={notification?.data?.type} />
  ) : (
    getDefaultIcon()
  );

  return iconComponent;
};

const styleMap = {
  ERROR: {
    backgroundColor: '#FCEDE9',
    border: '1px solid #EA4E2C',
    boxShadow: '0px 6px 16px 0px #EA4E2C24',
  },
  WARNING: {
    backgroundColor: '#FDF6E9',
    border: '1px solid #EE9500',
    boxShadow: '0px 6px 16px 0px #EE950024',
  },
  INFO: {
    backgroundColor: '#E6EFFA',
    border: '1px solid #0268D9',
    boxShadow: '0px 6px 16px 0px #0268D924',
  },
};

const getDefaultStyle = () => ({
  backgroundColor: '#E6EFFA',
  border: '1px solid #0268D9',
  boxShadow: '0px 6px 16px 0px #0268D924',
});

export const getNotificationStyle = (notification) => {
  const mappedStyle = styleMap[notification?.data?.type];
  const notificationStyle = mappedStyle ? mappedStyle : getDefaultStyle();

  return notificationStyle;
};

const buttonColorMap = {
  ERROR: {
    color: '#EA4E2C',
  },
  WARNING: {
    color: '#EE9500',
  },
  INFO: {
    color: '#0268D9',
  },
};

export const getCloseNotificationButtonColor = (notification) => {
  const mappedStyle = buttonColorMap[notification?.data?.type];
  const buttonStyle = mappedStyle
    ? mappedStyle
    : {
        color: '#0268D9',
      };

  return buttonStyle;
};
